module.exports = __webpack_public_path__ + "img/gazszallitas2.d34b9f02.jpg";